import {connect} from 'react-redux';
import DivisionNew from './DivisionNew';
import {
  requestEntityList,
  fetchEntityListNotDeleted,
  entitiesListIsDirty,
  setEntityDetailId,
  selectEntityUi,
  createNewDivision
} from '../../redux/actions/divisions';

const mapStateToProps = state => {
  return {
    app_state: state.app_state,
    divisions: state.divisions
  };
};

const mapDispatchToProps = dispatch => {
  return {
    requestEntityList: () => {
      dispatch(requestEntityList());
    },
    fetchEntityListNotDeleted: () => {
      dispatch(fetchEntityListNotDeleted());
    },
    entitiesListIsDirty: value => {
      dispatch(entitiesListIsDirty(value));
    },
    setEntityDetailId: id => {
      dispatch(setEntityDetailId(id));
    },
    selectEntityUi: value => {
      dispatch(selectEntityUi(value));
    },
    createNewDivision: data => {
      dispatch(createNewDivision(data));
    }
  };
};

const DivisionNewContainer = connect(mapStateToProps, mapDispatchToProps)(DivisionNew);

export default DivisionNewContainer;
